import ThemeMaker from '../../components/thememaker'
import { Flex, Space, Table, Tag, Button } from 'antd';
import { config } from '../../utils/config';
import axios from 'axios';
import jwt_decode from "jwt-decode";
import React, { useState, useEffect } from 'react'
import { EditOutlined } from "@ant-design/icons";
import { HiPencilSquare } from "react-icons/hi2";
import { useHistory } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { ToastContainer, toast } from 'react-toastify';
import { Modal, Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { SizeData, ColourData, FabricData, daysData, UOMData, MaterialData, ShoeSizedata, SizeDataBoyGirl } from '../../utils/rawdata';
import "../../components/mcrbTableTheme.css";


export default function Warehouse() {
  const history = useHistory();
  const Router = useHistory()
  const [isFandB, setisFandB] = useState(false)
  const { apiEndpoint, baseNodeapiUrl } = config;
  let rawToken = sessionStorage.getItem("us_st_d");
  var decode = jwt_decode(rawToken);
  const [data, setData] = useState([])
  const [loading, setLoading] = React.useState(false);

  // const columns = [
  //     {
  //         title: 'Name',
  //         dataIndex: 'name',
  //         key: 'name',
  //         render: (text) => <a>{text}</a>,
  //     },
  //     {
  //         title: 'Age',
  //         dataIndex: 'age',
  //         key: 'age',
  //     },
  //     {
  //         title: 'Address',
  //         dataIndex: 'address',
  //         key: 'address',
  //     },
  //     {
  //         title: 'Tags',
  //         key: 'tags',
  //         dataIndex: 'tags',
  //         render: (_, { tags }) => (
  //             <div className='d-flex align-items-center' gap="small" align="center" wrap>
  //                 {tags.map((tag) => {
  //                     let color = tag.length > 5 ? 'geekblue' : 'green';
  //                     if (tag === 'loser') {
  //                         color = 'volcano';
  //                     }
  //                     return (
  //                         <Tag color={color} key={tag}>
  //                             {tag.toUpperCase()}
  //                         </Tag>
  //                     );
  //                 })}
  //             </div>
  //         ),
  //     },
  //     {
  //         title: 'Action',
  //         key: 'action',
  //         render: (_, record) => (
  //             <Space size="middle">
  //                 <a>Invite {record.name}</a>
  //                 <a>Delete</a>
  //             </Space>
  //         ),
  //     },
  // ];
  const Sstyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
  };

  const columns = [
    {
      title: "Warehouse Name",
      dataIndex: "warehouse_name",
      key: "warehouse_name",
    },
    {
      title: "Warehouse Code",
      dataIndex: "warehouse_code",
      key: "warehouse_code",
    },
    {
      title: "Contact Person",
      dataIndex: "warehouse_contact_person",
      key: "warehouse_contact_person",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
    {
      title: "FSSAI License",
      dataIndex: "fssai_license_no",
      key: "fssai_license_no",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag color={status ? "green" : "red"}>
          {status ? "Active" : "Inactive"}
        </Tag>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <div
          className="text-success"
          onClick={() => handleEdit(record.id, record.location_id)}

        >
          <HiPencilSquare size={18} style={{ cursor: "pointer" }} />
        </div>
      ),
    }

  ];

  const [file, setFile] = useState(null);
  const [shipmentModalOpen, setshipmentModalOpen] = useState(false);
  const [downloadCSVModalOpen, setdownloadCSVModalOpen] = useState(false);
  const fullUrl = window.location.host;
  const handleFandBImport = async () => {
    try {
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const json = XLSX.utils.sheet_to_json(worksheet);
          let dataToSend = json.filter((item) => item.name !== null)
          // console.log("dataToSend----->", dataToSend)
          // return
          sendFandBDataToDb(dataToSend);

        };
        reader.readAsArrayBuffer(file);
      }

    } catch (error) {
      console.error('Error handling import:', error);
    }
  };

  const handleImportForProdXpressbazaar = async () => {
    try {
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const json = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

          // Get the headers from the first row of the sheet
          const headers = json[0];

          // Convert the rest of the sheet to JSON format
          const rows = XLSX.utils.sheet_to_json(worksheet);

          let errors = [];
          let dataToSend = rows.filter(item => item.name !== null).map((item) => {
            // Check for missing fields, excluding image2, image3, and image4
            const missingFields = headers.filter(header => {
              return (item[header] === null || item[header] === undefined) &&
                !['image1', 'image2', 'image3', 'image4', 'pf_brand_owner_FSSAI_license_no', 'transfer_price'].includes(header);
            });

            if (missingFields.length > 0) {
              const errorMessage = `Error in SKU: ${item.sku} - Missing fields: ${missingFields.join(', ')}`;
              errors.push(errorMessage);
              console.log(errorMessage);
              return null; // Skip this item in dataToSend
            }

            let tts = daysData.filter(items => items.name === item.time_to_ship);
            let rw = daysData.filter(items => items.name === item.return_window);
            let colourCode = item?.colour ? ColourData.filter(items => items.name === item.colour) : null;

            return {
              ...item,
              time_to_ship: tts[0]?.value,
              return_window: rw[0]?.value,
              // colour: colourCode ? colourCode[0]?.value : "#ffff",
              // colour_name: colourCode ? colourCode[0]?.name : "white"
            };
          }).filter(item => item !== null); // Filter out invalid items

          if (errors.length > 0) {

            const fileData = JSON.stringify(errors, null, 2);
            const blob = new Blob([fileData], { type: 'text/plain' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.download = 'error.txt';
            link.href = url;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            toast.error("Found error in excel! Error file is downloaded.")
          } else {
            sendDataToDb(dataToSend);
            console.log("datatosend -----------", dataToSend)
          }

        };
        reader.readAsArrayBuffer(file);
      }
    } catch (error) {
      console.error('Error handling import:', error.message);
    }
  };

  async function sendDataToDb(jsonData) {

    let apE;
    if (fullUrl === "multipleselleradmin.thesellerapp.com") {
      apE = "importProducts"
    } else {
      apE = "importxpProducts"
    }
    try {
      setLoading(true);
      let result = await axios({
        url: `${apiEndpoint}/${apE}`,
        method: 'POST',
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,

        },
        data: { "orders": jsonData },

      })
      setLoading(false);
      if (result.data.status == 200) {
        toast.success("Products added successfully !");
        setFile(null)
        document.getElementById('inputFile').value = ''
      } else {
        toast.error("Server Not Working, Please try later!");
      }
    } catch (error) {
      setLoading(false);
      toast.error("Server Not Working, Please try later!");
    }


  }


  async function sendDataToDb(jsonData) {

    let apE;
    if (fullUrl === "multipleselleradmin.thesellerapp.com") {
      apE = "importProducts"
    } else {
      apE = "importxpProducts"
    }
    try {
      setLoading(true);
      let result = await axios({
        url: `${apiEndpoint}/${apE}`,
        method: 'POST',
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("us_st_d")}`,

        },
        data: { "orders": jsonData },

      })
      setLoading(false);
      if (result.data.status == 200) {
        toast.success("Products added successfully !");
        setFile(null)
        document.getElementById('inputFile').value = ''
      } else {
        toast.error("Server Not Working, Please try later!");
      }
    } catch (error) {
      setLoading(false);
      toast.error("Server Not Working, Please try later!");
    }
  }

  async function sendFandBDataToDb(jsonData) {
    // let apiEndpoint = baseNodeapiUrl();
    console.log("jsonData---->", jsonData)
    const payload = {
      items: jsonData
    }
    // return
    try {

      let result = await axios({
        url: `${baseNodeapiUrl}/cms/customization/import-csv`,
        method: 'POST',
        headers: {
          "token": `${sessionStorage.getItem("us_st_d")}`,

        },
        data: payload,

      })

      console.log("result----->", result)


    } catch (error) {
      console.log(error)
      // toast.error(`${error?.response?.data?.error[0]?.message} for ${error?.response?.data?.error[0]?.email}`);
    }


  }

  const handleImport = (id, locationId) => {
    history.push(`/importwarehouse/${id}/${locationId}`);
  };
  const handleEdit = (id, locationId) => {
    history.push(`/addwarehouse/${id}/${locationId}`);
  };
  function handleShipementModalClose() {
    setshipmentModalOpen(false);
  };


  const getAllwarehouse = async () => {
    try {
      const response = await axios({
        url: `${apiEndpoint}/get-warehouse-list`,
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "X-Custom-Authorization": `Bearer ${rawToken}`
        },
      })
      setData(response?.data?.data || []);
    } catch (error) {
      console.log("Error -------->", error);
    }
  }


  useEffect(() => {
    getAllwarehouse();
  }, [])

  return (
    <ThemeMaker>
      <div className="mcrb-page">
        <div className="mcrb-card">
          <div className="mcrb-headbar">
            <span>Warehouses</span>
            <div style={{ display: "flex", gap: "10px" }}>
              <button type="button" onClick={() => setshipmentModalOpen(true)}>Import Warehouse</button>
              <button type="button" onClick={() => Router.push("/addwarehouse")}>Add Warehouse</button>
            </div>
          </div>
          <div className="mcrb-antd" style={{ padding: "16px 20px 22px", maxHeight: "76vh", overflowY: "auto", scrollbarWidth: "none" }}>
              <div className="row">
                <div className="w-100">
                  <div className="text-center">
                    <Table columns={columns} dataSource={data} rowKey="id" />
                  </div>

                </div>
              </div>
            </div>
            <Modal
              open={shipmentModalOpen}
              onClose={handleShipementModalClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box sx={Sstyle} className="col-md-4 ">

                <div className="modal-content " >
                  <div className="modal-header p-2 d-flex align-items-center justify-content-between">
                    <p className="modal-title genericlabel  " style={{ letterSpacing: "1px" }}>Import Using Excel File..     <span className="text-primary ml-2" style={{ cursor: "pointer" }} onClick={() => { setdownloadCSVModalOpen(true) }} > Download Sample Excel</span> </p>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                      <span style={{ cursor: "pointer" }} ><CloseIcon onClick={handleShipementModalClose} /></span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="importingSection">
                      <input type="file" id="inputFile" onChange={(e) => {
                        setFile(e.target.files[0]);
                      }} /> <br />

                      {/* <span className='text-danger font-weight-bold text-small'>Only CSV Files</span> */}


                    </div>
                  </div>
                  {/* <div className="modal-body">
                    <input type="checkbox" onChange={() => setisFandB(!isFandB)} /> <label>Is product type F&B? </label>
                  </div> */}
                  {!isFandB ? <div className="modal-footer">
                    {/* <button className="btn btn-primary" onClick={handleImport} > Submit </button> */}
                    {fullUrl === "multipleselleradmin.thesellerapp.com" ? <button className="btn btn-primary" onClick={handleImport} > Submit </button> : <button className="btn btn-primary" onClick={handleImportForProdXpressbazaar} > Submit </button>}
                  </div> : <div className="modal-footer"> <button className="btn btn-primary" onClick={handleFandBImport} > Save </button></div>}
                </div>
              </Box>
            </Modal>
        </div>
      </div>

    </ThemeMaker>
  )
}
